import { RouteConfig } from "vue-router";

import Layout from "@/layout/index.vue";

const settingsRouter: RouteConfig = {
  path: "/sys",
  name: "sys",
  component: Layout,
  meta: {
    title: "系统管理",
    icon: "setting",
    permission: "Pages.Settings"
  },
  children: [
    {
      path: "user",
      name: "User",
      component: () =>
        import(
          /* webpackChunkName: "user" */ "@/views/settings/user/index.vue"
        ),
      meta: {
        title: "用户管理",
        permission: "Pages.Settings.User"
      }
    },

    {
      path: "role",
      name: "Role",
      component: () =>
        import(
          /* webpackChunkName: "role" */ "@/views/settings/role/index.vue"
        ),
      meta: {
        title: "角色管理",
        permission: "Pages.Settings.Role"
      }
    },
    {
      path: "role/create",
      name: "CreateRole",
      component: () =>
        import(
          /* webpackChunkName: "create-role" */ "@/views/settings/role/create-role.vue"
        ),
      meta: {
        title: "添加角色",
        hidden: true,
        permission: "Pages.Settings.Role.Create"
      }
    },
    {
      path: "role/update/:id",
      name: "UpdateRole",
      component: () =>
        import(
          /* webpackChunkName: "update-role" */ "@/views/settings/role/update-role.vue"
        ),
      meta: {
        title: "修改角色",
        hidden: true,
        permission: "Pages.Settings.Role.Update"
      }
    },
    {
      path: "audit-log",
      component: () =>
        import(
          /* webpackChunkName: "audit-log" */ "@/views/settings/audit-log/index.vue"
        ),
      meta: {
        title: "审计日志",
        permission: "Pages.Settings.AuditLog"
      }
    },
     {
      path: "userPurview",
      name: "userPurview",
      component: () =>
        import(
          /* webpackChunkName: "user" */ "@/views/settings/userPurview/index.vue"
        ),
      meta: {
        title: "修改会员权限管理",
        permission: "Pages.Settings.User"
      }
    },
    {
      path: "allAnglysis",
      name: "allAnglysis",
      component: () =>
        import(
          /* webpackChunkName: "user" */ "@/views/educationalIdentity/allAnalysis/index.vue"
        ),
      meta: {
        title: "学校分析",
        permission: "Pages.Settings"
      }
    },
    {
      path: "analysis",
      name:'analysisNew',
      component: () =>
        import(
          /* webpackChunkName: "score-settings" */ "@/views/educationalIdentity/index.vue"
        ),
      meta: {
        title: "学校分析",
        icon: "setting",
        permission: "Pages.Settings"
      }
    },
  ]
};

export default settingsRouter;
